/**
 * Withdraw Method View
 */

define(function(require, exports, module) {
    'use strict';

    const $ = require('j');
    const _ = require('underscore');
    const core = require('core');
    const Form = require('class/form.class');
    const CashierMethodView = require('portlets/cashier/cashier.method.view');
    const url = require('util/url.util');
    const dispatcher = require('bundle').dispatcher;
    const cashierUtil = require('modules/cashier/cashier.util');

    module.exports = CashierMethodView.extend({

        className: _.result(CashierMethodView.prototype, 'className') + ' fn-withdraw-method',

        events: _.extend(CashierMethodView.prototype.events, {
            'change .fn-change-predefined-city': 'onPredefinedCityChange',
            'change .fn-change-predefined-shop': 'onPredefinedShopChange',
            'submit form': 'withdrawAction'
        }),

        defaultTemplateName: 'withdraw.method',

        // todo Use CashierMethodModel.generateAccountTitle() method
        getAccountIdTitle: function(code) {
            var account = this.model.get('account');
            var title = code ? String(code) : '';

            if (account && _.isArray(account)) {
                account.forEach(function(acc) {
                    if (acc.specificParams && acc.specificParams.accountId) {
                        if (acc.code === code || acc.specificParams.accountId === code) {
                            return title = acc.specificParams.accountId;
                        }
                    }
                });
            }

            return title;
        },

        withdrawAction: function(e) {
            e.preventDefault();

            return this.form.validate().done(function(data) {
                this.hideKeyboard();

                data = this.model.resolveStoredAccount(data);

                this.withdrawConfirm(data);
            }.bind(this));
        },

        withdrawConfirm: function(data) {
            var amount = window.Playtech.API.formatter.formatCurrency(data.amount);
            var translationKey = 'playtech.mobile.system.mobile-cashier.withdraw.success.accept';

            var content = data.content || (data.accountId
                    ? this.translate(translationKey, amount, this.getAccountIdTitle(data.accountId))
                    : this.translate(translationKey + '-no-account', amount));

            var title = this.translate('playtech.mobile.system.mobile-cashier.withdraw.title');

            window.Playtech.API.popup.showPopup('confirmation', {
                title,
                content,
                onAccept: this.withdrawSendRequest.bind(this, data)
            });
        },

        withdrawSendRequest: function(data) {
            let extPaymentWindow;
            const config = this.model.get('config');

            this.form.showLoading();

            if (config.redirect && config.redirectType === 'popup') {
                extPaymentWindow = url.openNewWindow('', '');
            }

            this.model.withdraw(data)
                .done(response => this.withdrawSuccess(response, extPaymentWindow))
                .fail(error => this.withdrawFail(data, error, extPaymentWindow))
                .always(() => this.form.hideLoading());
        },

        withdrawSuccess: function(response, extPaymentWindow) {
            if (response.data.headerParameters) { // is redirect PM
                this.performRedirect(response, extPaymentWindow);
            } else {
                const { amount, status, transactionCode } = response.data?.payments?.transaction[0] ?? {};

                core.trigger('withdraw:success', { amount, status, transactionCode, method: this.model.get('name') });
            }
        },

        withdrawFail: function(data, response, extPaymentWindow) {
            extPaymentWindow && extPaymentWindow.close();

            if (!response) {
                this.form.showErrorMessage({
                    translation: 'playtech.mobile.system.error.no.response'
                });

                return;
            }

            if (response?.data?.errorCode === 303) {
                this.showTwoFactorAuthPopup(data);

                return;
            }

            var errorMessage = response.data.errorMessage
                || response.data.error && response.data.error.message
                || null;

            // Currency conversion, fee, lose bonus
            var knownError = this.handleError(response.data.error);

            if (knownError) {
                data.title = response.data.error.severity;
                data.content = errorMessage;
                data[knownError.type] = true;

                this.withdrawConfirm(data);
            } else {

                var pekoErrorMessage = cashierUtil.getErrorMessage(response);
                if (pekoErrorMessage) {
                    this.form.showErrorMessage({
                        content: pekoErrorMessage
                    });
                } else {
                    this.form.showErrorMessage({
                        translation: 'playtech.mobile.system.mobile-cashier.error.' + response.data.errorCode,
                        content: errorMessage
                    });
                }
            }

            core.trigger('withdraw:fail', response.data);

            this.handleActionableError(response);
        },

        onPredefinedCityChange: function(e) {
            var citySelect = e.target;
            var city = citySelect.value;
            var $container = $(citySelect).parents('.fn-predefined-values-field-container');
            var index = parseInt($container[0].dataset.fieldIndex);
            var field;
            var data;

            this.model.set({
                _predefinedCitySelected: city
            });

            if (!this._isShopChanging) {
                this.model.set('_predefinedShopSelected', null);
            }
            this._isShopChanging = false;

            data = this.model.toJSON();
            field = data.accountFields.field[index];

            this.updateShopsDropDown(
                $container,
                data._predefinedShopSelected,
                field.shopsByCity[city]
            );
        },

        updateShopsDropDown: function($cityContainer, selectedShop, cityShops) {
            const $shopsDropDownWrapper = $cityContainer.find('.fn-predefined-value-shop .fn-validate');
            const shopsDropDown = $cityContainer.find('.fn-predefined-shop')[0];
            const fragment = document.createDocumentFragment();

            if (!this.shopsDropDownOptions) {
                this.shopsDropDownOptions = shopsDropDown.querySelectorAll('option');
            }

            this.shopsDropDownOptions.forEach((option, index) =>
                (index === 0 && !option.value || cityShops.find(shop => shop.value === option.value))
                && fragment.appendChild(option.cloneNode(true))
            );

            shopsDropDown.innerHTML = '';
            shopsDropDown.appendChild(fragment);

            shopsDropDown.childNodes.forEach((node, index) =>
                node.selected = node.value === selectedShop || index === 0);

            Form.refreshSelectField(shopsDropDown);
            this.form.resetField($shopsDropDownWrapper);
        },

        /**
         * Dirty hack as it is
         * @param e
         */
        onPredefinedShopChange: function(e) {
            var shopEl = e.target;
            var shop = shopEl && shopEl.value;
            var $container = $(shopEl).parents('.fn-predefined-values-field-container');
            var index = parseInt($container[0].dataset.fieldIndex);
            var field = this.model.get('accountFields').field[index];
            var predefinedValues = field.predefinedFieldValues.predefinedFieldValue;

            var city = (_.find(predefinedValues, function(val) {
                return val && val.value === shop;
            }) || {}).label2;

            this.model.set('_predefinedShopSelected', shop);

            var $cityEl = $container.find('.fn-predefined-city');
            $cityEl.val(city);

            // because jBone doesn't allow to pass extra data in event
            this._isShopChanging = true;
            $cityEl.trigger('change');
        },

        /**
         * @override
         * @param e
         */
        addAnotherAccount: function(e) {
            CashierMethodView.prototype.addAnotherAccount.apply(this, arguments);

            if (this.model.get('hasPredefinedValues')) {
                this.handleAccountChangeForPredefinedValues(e);
            }
        },

        /**
         * @override
         * @param e
         */
        handleChangeMultiFieldAccount: function(e) {
            CashierMethodView.prototype.handleChangeMultiFieldAccount.apply(this, arguments);

            if (this.model.get('hasPredefinedValues')) {
                this.handleAccountChangeForPredefinedValues(e);
            }
        },

        handleAccountChangeForPredefinedValues: function(e) {
            var accountValue = e.target.value;
            var data = this.model.toJSON();
            var selectedAccount;

            if (accountValue && accountValue !== 'add') {
                selectedAccount = _.find(data.account, {
                    code: accountValue
                });

                if (selectedAccount) {
                    this.model.set({
                        _selectedAccount: selectedAccount
                    });

                    this.model.set({
                        _predefinedCitySelected: undefined,
                        _predefinedShopSelected: undefined
                    }, { unset: true });

                    this.updateFieldsWithPredefinedValues();
                }
            } else if (accountValue === 'add') {
                this.model.unset('_selectedAccount');

                this.updateFieldsWithPredefinedValues();
            }
        },

        /**
         * Re-renders dropdowns for predefined value fields
         */
        updateFieldsWithPredefinedValues: function() {
            var data = this.model.toJSON();

            data.accountFields.field.forEach(function(field, index) {
                this.$('.fn-predefined-values-field-container[data-field-index="' + index + '"]')
                    .html(this.tmpl('withdraw.method.predefinedValueDropdowns', {
                        method: data,
                        field: field,
                        idx: index
                    }));
            }.bind(this));

            this.form.wrapFormControls();
        },

        isHiddenField: function(field, method) {
            if (method.reDirectType === 'jspaysafe') {
                return true;
            }

            return CashierMethodView.prototype.isHiddenField.apply(this, arguments);
        },

        showTwoFactorAuthPopup: function(data) {
            dispatcher.dispatch('app:message', {
                ID: 'twoFactorAuthentication',
                data: {
                    onCancel: () => {
                        dispatcher.dispatch('2fa-popup-closed', 'withdraw');
                    },
                    onSuccess: this.withdrawSendRequest.bind(this, data),
                    resendHandler: this.resendTwoFactorAuthPin.bind(this, data)
                }
            });
        },

        /**
         * Needed for request pin code within Two Factor Auth popup
         */
        resendTwoFactorAuthPin: function(data) {
            this.model.withdraw(data);
        }
    });
});
